export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_ROLES_OK = 'FETCH_ROLES_OK';
export const FETCH_ROLES_FAILED = 'FETCH_ROLES_FAILED';

export const ADD_ROLE = 'ADD_ROLE';
export const ADD_ROLE_OK = 'ADD_ROLE_OK';
export const ADD_ROLE_FAILED = 'ADD_ROLE_FAILED';

export const FETCH_ROLE_ID = 'FETCH_ROLE_ID';
export const FETCH_ROLE_ID_OK = 'FETCH_ROLE_ID_OK';
export const FETCH_ROLE_ID_FAILED = 'FETCH_ROLE_ID_FAILED';

export const PATCH_ROLE = 'PATCH_ROLE';
export const PATCH_ROLE_OK = 'PATCH_ROLE_OK';
export const PATCH_ROLE_FAILED = 'PATCH_ROLE_FAILED';

export const RESET_ROLE = 'RESET_ROLE';

